import React, { useState, useEffect } from 'react';
// import loadable from '@loadable/component';
import '../assets/styles/user_page.scss';
import Axios from 'axios';
import { Images, Colors } from '../constants';
import Error from '../components/errors/Error';
import LoadingPageView from '../components/loading/UserPage';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../custom_hooks/useWindowDimensions';
import { Confirm } from '../components/button';
// import LoadingDisplayMeeting from '../components/loading/DisplayedMeeting';
import { hex_to_rgba } from '../custom_functions/hex_to_rgba';

// const DisplayedMeetingsView = loadable(() => import('../components/user/DisplayedMeeting'), {
//   fallback: <LoadingDisplayMeeting />,
// });
import DisplayedMeetings from '../components/user/DisplayedMeeting';
// const APP_URL = 'https://timesync.novocall.co';

const UserPage = (props) => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ isError, setIsError ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState(null);
  const [ userPath, setUserPath ] = useState(`${process.env.REACT_APP_BACKEND_URL}/api/internal/v1/events`);
  // const [ userPath, setUserPath ] = useState(`${APP_URL}/api/internal/v1/events`);
  const [ urlPath, setUrlPath ] = useState('');
  const [ showButtonConfirm, setShowButtonConfirm ] = useState(false);
  const [ meetingLink, setMeetingLink ] = useState(null);
  const [ languageCode, setLanguageCode ] = useState('en');
  const [ data, setData ] = useState(null);
  const { width } = useWindowDimensions();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const { user_path, team_path } = props.match.params;
    // set url params
    if(user_path) {
      setUrlPath(`${userPath}?user_path=${user_path}`);
      setUserPath(`/${user_path}`);
    }
    else if(team_path) {
      setUrlPath(`${userPath}?team_path=${team_path}`);
      setUserPath(`/t/${team_path}`);
    } else if (window.location.hostname !== process.env.REACT_APP_BASE_URL) {
      setUrlPath(`${userPath}?custom_domain=${window.location.hostname}`);
      setUserPath('');
    } else {
      window.location = 'https://novocall.co/timesync-call-scheduling-software/'
    }
  },
  // eslint-disable-next-line
  []);

  // set language code
  useEffect(() => {
    if(data) {
      if(data.language_code){
        setLanguageCode(data.language_code)
      }
      else {
        setLanguageCode(navigator.language.split("-", 1).toString() || 'en');
      }
    }
  },
  [data]);

  // change language
  useEffect(() => {
    if(languageCode){
      i18n.changeLanguage(languageCode);
    }
  },
  // eslint-disable-next-line
  [languageCode]);

  useEffect(() => {
    async function getData(path){
      try{
        if(path.length > 0){
          Axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
          Axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
          Axios.defaults.headers.post['Cross-Origin-Embedder-Policy'] = 'require-corp';
          Axios.defaults.headers.post['Cross-Origin-Opener-Policy'] = 'same-origin';

          await Axios.get(path)
            .then((response)=>{
              if(response.status === 200 && response.data.data){
                setData(response.data.data);
                setIsLoading(false);
                setErrorMessage(null);
              }
              else{
                setIsError(true);
                setIsLoading(false);
              }
            })
            .catch(error => {
              setErrorMessage(error.response.data.error);
              setIsLoading(false);
            })
        }
      }
      catch(error){
        setErrorMessage(error.message);
      }
    }

    if(urlPath){
      setIsLoading(true);
      // get data
      getData(urlPath);
    }
  }, [urlPath]);

  useEffect(() => {
    if(errorMessage) setIsError(true);
    else setIsError(false);

    setIsLoading(false);
  }, [errorMessage]);

  // handle meeting clicked
  useEffect(() => {
    if(meetingLink){
      checkWindowLocation(meetingLink);
    }
  },
  // eslint-disable-next-line
  [meetingLink, width]);

  // check if width > 425 then redirect to the meeting
  const checkWindowLocation = (href) => {
    if( width > 425 ){
      window.location = href;
    }
    else{
      setShowButtonConfirm(true);
    }
  };

  // set on click function
  const handleMeetingOnClick = (href = false, meetingId = false) => {
    if(href){
      setMeetingLink(href);
      handleViewMeetingSelected(meetingId);
      checkWindowLocation(href);
    }
  };

  // to show which meeting selected
  const handleViewMeetingSelected = (meetingId) => {
    // text
    var text = document.getElementsByClassName('content-text');
    if(text.length > 0){
      for(let i = 0; i<= text.length; i++ ){
        if(text[i] !== undefined){
          text[i].style.color = `#${Colors.blackText}`;
        }
      }
    }

    // svg
    var svgs = document.getElementsByClassName('svg-icon-custom');
    if(svgs.length > 0){
      for(let i = 0; i<= svgs.length; i++ ){
        if(svgs[i] !== undefined){
          svgs[i].style.stroke = `#${Colors.blackText}`;
        }
      }
    }

    // clear border selected
    let buttons = document.getElementsByClassName('content-link');
    if(buttons.length > 0){
      for(let i = 0; i<= buttons.length; i++ ){
        if(buttons[i] !== undefined){
          buttons[i].style.borderColor = `#${Colors.borderGray}`;
        }
      }
    }

    // border
    let meetingLinkButton = document.getElementById(`link-${meetingId}`);
    if(meetingLinkButton){
      meetingLinkButton.style.borderColor = `#${data.layout_color}`;
    }

    var elements = document.getElementsByClassName(meetingId);
    if(elements.length > 0){
      for(let i = 0; i<= elements.length; i++ ){
        if(elements[i] !== undefined){
          var tag_name = elements[i].tagName.toLowerCase();
          if(tag_name === 'path'){
            elements[i].style.stroke = `#${data.layout_color}`;
          }
          else{
            elements[i].style.color = `#${data.layout_color}`;
          }

        }
      }
    }
  };

  // callback function for button confirm
  const confirmButtonOnClick = () => {
    if(meetingLink){
      window.location.href = meetingLink;
    }
  }

  if(width > 425 && meetingLink){
    setMeetingLink(null);
    setShowButtonConfirm(false);
  }

  if(isLoading) return <LoadingPageView />;
  if (isError) return <Error errorMessage={errorMessage} />;
  if(!data) return null;

  return(
    <div className="user-page">
      <div className="container">

        <div className="left" style={{backgroundColor: hex_to_rgba(`#${data.layout_color || Colors.primaryColor}`, 0.05), boxShadow: `inset -1.063rem 0 1.25rem ${hex_to_rgba(`#${data.layout_color || Colors.primaryColor}`, 0.05)}` }}>
          <div className="section-top">
            <div className="photo">
              <img alt="userPhoto" className="photo-image" src={data.logo} />
            </div>
            <div className="name">
              <div className={"name-text"}>
                  {data.displayed_name}
              </div>
            </div>
          </div>
          <div className="section-bottom">
            <div className="description-wrap">
              <div className="description-text" dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
          </div>
        </div>

        <div className="right-content">
          <div className="content-wrap-overflow">
            <div className="user-content-wrap">
              <div className="header">
                <h3>{ t('Choose Meeting Types') }</h3>
              </div>
            </div>

            <div className="user-content-wrap">
              <div className="displayed-meetings">
                <DisplayedMeetings
                  languageCode={languageCode}
                  displayedMeetings={data.displayed_meetings}
                  userPath={userPath}
                  handleMeetingOnClick={handleMeetingOnClick}
                  focusClass={showButtonConfirm ? '-focus' : ''}
                  color={`#${data.layout_color}`} />
              </div>
            </div>
          </div>


          { !data.remove_branding && (
            <div className="right-footer"
              style={{
                height: width <= 850 ? (width < 425 ? '6rem' : '7rem') : '1rem',
                top: (width < 625 && width >= 425) ? '1rem' : '0',
                bottom: (width <= 425) ? '3rem' : '0',
                position: (width <= 850) ? 'relative' : 'absolute'
              }}>
              <p className="footer-text">
                { t('Powered by') }
              </p>
              <a href={process.env.REACT_APP_WEB_URL} rel="noopener" target={'_blank'}>
                <img alt="novocall-icon" className="right-footer-icon" width="75" height="15" src={Images.novocallLogo} />
              </a>
            </div>
          )}


          <Confirm
            confirmButtonOnClick={confirmButtonOnClick}
            color={`#${data.layout_color}`}
            disabled={!showButtonConfirm} />
        </div>

      </div>
    </div>
  );

};

export default UserPage;
